import { RestApiResponseFormatType } from '../Enums/rest-api-response-format-type';
import { RestApiResponseVariableConfiguration } from './rest-api-response-variable-configuration';

export class RestApiResponseConfiguration {
    public responseFormatType: RestApiResponseFormatType;
    public responseVariableConfigurations: RestApiResponseVariableConfiguration[] = [];
    public datasourcePath: string;

    /**
     * Retourne une copie d'une instance de RestApiResponseConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiResponseConfiguration) {
        if (!!other) {
            const instance = new RestApiResponseConfiguration();

            instance.responseFormatType = other.responseFormatType;
            instance.responseVariableConfigurations = RestApiResponseVariableConfiguration.cloneArray(other.responseVariableConfigurations);
            instance.datasourcePath = other.datasourcePath;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiResponseConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiResponseConfiguration[]) {
        if (!!others) {
            let responses: RestApiResponseConfiguration[] = [];

            others.forEach((x) => {
                const response = RestApiResponseConfiguration.clone(x);
                responses.push(response);
            });

            return responses;
        } else {
            return [];
        }
    }
}
